module.exports = __webpack_public_path__ + "img/chinesecompany183.535a02a2.png";